import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { KsefSendParametersBO, KsefSendParametersQuery } from '@skylab-shared/business';
import { EventBusBase, RepositorySaveResponse } from '@skylab-shared/core';
import { EnumTranslatorBase, KsefSendParametersModel, KsefSendParametersSalePatternSendMode, KsefSendSubmissionMode, LabeledEnumValueConverter, SaleSendToKsefValidationWarning } from '@skylab-shared/dataModel';

import { KsefSendParametersRepository, KsefSendParametersRepositoryBase } from '@skylab-angular-shared/business';
import { CommandBus, EnumTranslator, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FormContainerComponent, SelectValueAccessorDirective, ToastService, TooltipDirective, ValidationSourceDirective, IconComponent } from '@skylab-angular-shared/ui';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';

@Component({
	selector: 'skl-ksef-send-parameters-dialog',
	templateUrl: './ksef-send-parameters-dialog.component.html',
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [TooltipDirective, DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, FormsModule, ButtonComponent, TranslatePipe, BooleanValueAccessorDirective, SelectValueAccessorDirective, IconComponent]
})
export class KsefSendParametersDialogComponent extends DictionaryDialogComponentBase<KsefSendParametersModel, KsefSendParametersBO, KsefSendParametersRepositoryBase, DictionaryDialogViewModelBase<KsefSendParametersBO>> {
	salePatternSendModes = this.enumTranslator.getLabeledEnumValueArray(KsefSendParametersSalePatternSendMode);
	salePatternSendModesConverter = new LabeledEnumValueConverter(this.enumTranslator, KsefSendParametersSalePatternSendMode);
	documentTypes = this.enumTranslator.getLabeledEnumValueArray(KsefSendSubmissionMode).filter(e => e.value !== KsefSendSubmissionMode.Emergency);
	documentTypesConverter = new LabeledEnumValueConverter(this.enumTranslator, KsefSendSubmissionMode);
	ksefWarnings = this.enumTranslator.getLabeledEnumValueArray(SaleSendToKsefValidationWarning);

    indeksTooltip = this.ksefWarnings.find(e => e.value === SaleSendToKsefValidationWarning.DocumentItemsWithTooLongSymbol)?.label ?? ''
    gtinTooltip = this.ksefWarnings.find(e => e.value === SaleSendToKsefValidationWarning.DocumentItemsWithTooLongBarCode)?.label ?? ''

	public constructor(
		@Inject(KsefSendParametersRepository) KsefSendParametersRepository: KsefSendParametersRepositoryBase,
		@Inject(Weaver) weaver: WeaverBase,
		@Inject(L10n) l10n: L10nBase,
		@Inject(EventBus) eventBus: EventBusBase,
		@Inject(RootContext) private readonly rootContext: RootContextBase,
		@Inject(EnumTranslator) private readonly enumTranslator: EnumTranslatorBase,

		toastService: ToastService,
		commandBus: CommandBus,
		dialogService: DialogInsService,
	) {
		super(KsefSendParametersRepository, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
	}

	protected override get dictionaryToLoadProperties(): any {
		return {};
	}

	protected override onSaveSuccess(response?: RepositorySaveResponse): void {
		super.onSaveSuccess(response);
		this.rootContext.refresh(KsefSendParametersQuery);
		this.toastService.showAsync({
			text: this.l10n._T('scenes.configuration.shared.ksef-send-parameters.dialog.message.success'),
			type: 'success'
		});
	}

	protected override onSaveError(response?: RepositorySaveResponse): void {
		this.toastService.showAsync({
			text: this.l10n._T('scenes.configuration.shared.ksef-send-parameters.dialog.message.error'),
			type: 'success'
		});
	}
}
